export default __webpack_public_path__ + "media/zurb/img/ecommerce/tmw_landing-fa4d8dc8aa110ca0b90e7aab59653ac5.png";